var React = require('react');

function UiCheckmark (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"ui-checkmark"),React.createElement("path",{"d":"M11.5,0A11.5,11.5,0,1,0,23,11.5,11.51,11.51,0,0,0,11.5,0Zm5.77,8.36L9.89,16.45l-3.7-3.7A.88.88,0,0,1,7.44,11.5l2.39,2.39L16,7.17a.89.89,0,0,1,1.25-.06A.89.89,0,0,1,17.27,8.36Z","key":1})]);
}

UiCheckmark.defaultProps = {"role":"presentation","viewBox":"0 0 23 23"};

module.exports = UiCheckmark;

UiCheckmark.default = UiCheckmark;
